import { useDispatch } from 'react-redux';

import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';
import { ToastMessage } from '../components/ToastMessage';
import { getManageMessageCategoriesNames } from '../modals/ManageCustomCategoriesModal/ManageCustomCategoriesModal.utils';
import { pluralizeCategory } from '../utils';
import {
  ManageMessageCategoriesOptions,
  useManageMessageCategories,
} from './useManageMessageCategories';

const DELETE_MESSAGE_CATEGORY_ERROR_MESSAGE = 'Error processing deletions. Please try again.';

export const useDeleteMessageCategories = (options?: ManageMessageCategoriesOptions) => {
  const dispatch = useDispatch();

  const {
    failure,
    isLoading,
    manageMessageCategories: deleteMessageCategories,
    reset,
  } = useManageMessageCategories({
    ...options,
    onError: () => {
      dispatch(addNegativeToast(DELETE_MESSAGE_CATEGORY_ERROR_MESSAGE));
    },
    onCompleted: (data) => {
      const _failure = data?.manageMessageCategories?.failure;

      if (_failure) {
        dispatch(addNegativeToast(DELETE_MESSAGE_CATEGORY_ERROR_MESSAGE));
      } else {
        const deletedCategories = data?.manageMessageCategories?.deleted ?? [];
        const names = getManageMessageCategoriesNames(deletedCategories);
        const message = `${pluralizeCategory(deletedCategories)} successfully deleted.`;

        dispatch(addPositiveToast(<ToastMessage name={names} message={message} />));
      }
    },
  });

  return {
    failure,
    isLoading,
    reset,
    deleteMessageCategories,
  };
};
